import '@progress/kendo-theme-bootstrap/dist/all.css';
import 'jquery/dist/jquery.min.js';
import React from 'react';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import DashboardWrapper from './DashboardWrapper';
import { Link } from 'react-router-dom';
/**
 * @author:Sandeep Sirohi
 * @description: Home page for dashboard after login. Placeholder.
 */
class DashboardHome extends React.Component {

    constructor(props: any) {
        super(props)
    }

    componentDidMount = async () => {
    }

    /**
     * Render the UI.
     * @returns
     */
    render() {
        return (
            <DashboardWrapper>
                <div className="DashboardWrapperChild">
                    <Sidebar />
                    <div className="contentWrapper">
                        <HeaderDashboard title="CMS Home" />
                        <div className="container-fluid mt-80 p-0">
                            <div className="row" style={{ height: "90vh" }}>
                                <div className="logoDashboardSidebarWrapper" style={{border:"0"} }>
                                    <img src={process.env.PUBLIC_URL + '/assets/images/logo/home-icon.png'} className="dashboard-home-image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DashboardWrapper>
        )
    }
};
export default DashboardHome;
